import React, { useState, useRef, useEffect } from 'react';

// Tooltip reutilizable para iconos info (ⓘ).
// - Desktop: aparece on hover (mouseenter / mouseleave).
// - Mobile: aparece on tap, se cierra con tap fuera.
// - Auto-flip vertical: si no entra abajo, se posiciona arriba del trigger.
//
// Props:
//   text       string  — contenido (puede ser ReactNode también)
//   maxWidth   number  — ancho máximo en px (default 220)
//   children   element — opcional; si se omite, renderiza un ⓘ circular
//
export default function Tooltip({ text, maxWidth = 220, children }) {
  const [open, setOpen] = useState(false);
  const [placement, setPlacement] = useState('bottom'); // 'top' | 'bottom'
  const wrapperRef = useRef(null);
  const popRef = useRef(null);

  // Cerrar al click afuera (mobile/desktop)
  useEffect(() => {
    if (!open) return undefined;
    function onDocClick(e) {
      if (wrapperRef.current && !wrapperRef.current.contains(e.target)) {
        setOpen(false);
      }
    }
    document.addEventListener('mousedown', onDocClick);
    return () => document.removeEventListener('mousedown', onDocClick);
  }, [open]);

  // Auto-flip al abrir
  useEffect(() => {
    if (!open || !wrapperRef.current || !popRef.current) return;
    const rect = wrapperRef.current.getBoundingClientRect();
    const popH = popRef.current.offsetHeight || 60;
    const spaceBelow = window.innerHeight - rect.bottom;
    setPlacement(spaceBelow >= popH + 12 ? 'bottom' : 'top');
  }, [open]);

  return (
    <span
      ref={wrapperRef}
      className="info-tooltip-wrap"
      onMouseEnter={() => setOpen(true)}
      onMouseLeave={() => setOpen(false)}
    >
      <button
        type="button"
        className="info-icon"
        aria-label="Más información"
        onClick={(e) => {
          e.stopPropagation();
          setOpen((v) => !v);
        }}
      >
        i
      </button>
      {open && (
        <span
          ref={popRef}
          className={`tooltip-pop tooltip-pop--${placement}`}
          style={{ maxWidth }}
          role="tooltip"
          onClick={(e) => e.stopPropagation()}
        >
          {text}
        </span>
      )}
    </span>
  );
}
